import { useStore } from "../../../stores/RootStoreContext"
import { CurrencyReplenishmentClient } from "@/components/client/currencyReplenishment/CurrencyReplenishmentClient"
import { CurrencyReplenishmentManager } from "@/components/manager/currencyReplenishment/CurrencyReplenishmentManager"

export const CurrencyReplenishment = () => {
  const { userStore } = useStore()

  if (userStore.isClient) {
    return <CurrencyReplenishmentClient />
  } else if (userStore.isManagement) {
    return <CurrencyReplenishmentManager />
  } else {
    return <></>
  }
}
